import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { prefixLocalePath } from '~/utils/prefixLocalePath';

/**
 * Locale-prefixed path of the Academy home page, e.g. `/de-de/academ`.
 * Where the consent flow ends, both from the waiting page and from the fallback story guard.
 */
export const useAcademyHomeUrl = (route?: RouteLocationNormalizedGeneric) => {
    const { urlSegment } = useLanguage(route);
    const academyPath = useRequiredSectionPathById('academy');

    return computed(() => prefixLocalePath(academyPath.value, urlSegment.value));
};
